module.exports = __webpack_public_path__ + "img/icon-pasien.0894c4c7.png";